// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import {fetchStaffData,staffStatusChange,deleteStaff} from "../../../Redux/Slices/mainSlice"

// Custom layout
import MainLayout from "../../../Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../Assets";
import Modal from "Components/Common/Modal";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";

const StaffManagement = () => {
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
    },
    {
      label: "Staff Name",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "name"})
      },
    },
    {
      label: "Mobile Number",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "mobile"})
      },
    },
    {
      label: "Email Id",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "email"})
      },
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "status"})
      },
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const [staffList, setStaffList] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "createdAt" });
  const [search, setSearch] = useState('')
  // to trigger rerender after status change
  const [staffStatus, setStaffStatus] = useState(1)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setSearch(value)
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  const changeStatus = (status,id) => {
    let statusName = "active"
    if(status == 2){
      statusName = "inactive"
    }
    dispatch(
      staffStatusChange({
        data:{
          status:statusName,
          id:id
        },
        callBack: staffStatusChangeCB,
      })
    )
  }
  
  const deleteIndividualStaff = ()=>{
    if (userToDelete) {
    dispatch(
      deleteStaff({
      data:{
        id:userToDelete
      },
      callBack: deleteStaffCB,
    }))
  }
  setIsModalOpen(false);
  }

  useEffect(() => {
    setCurrentPage(1)
  }, [search])

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchStaffData({
        data: {
          search:search,
          page: currentPage,
          limit:"10",
          sort_by:sortOptions.sort_by?"ASC":"DESC",
          order_by: sortOptions.order_by,
          role:"3"
        },
        callBack: staffListCB,
      })
    );
  },[sortOptions,currentPage,staffStatus,search])

  const staffListCB = (value) => {
    setStaffList(value?.data?.data_list || value.data)
    setTotalPage(value?.data?.pageMeta?.totalPages || 1)
    setTotalCount(value?.data?.pageMeta?.total || 0);
    setIsLoading(false)
  };

  const staffStatusChangeCB = (value) => {
    //triggers rerender after status change
    setStaffStatus(!staffStatus)
    //closes the options menu
    setOpenMenuId(null)
  };

  const deleteStaffCB = (value) => {
    console.log(value)
     notifySuccess("Staff Deleted Successfully")
     //triggers rerender after status change
     setStaffStatus(!staffStatus)
     //closes the options menu
     setOpenMenuId(null)
  }

  const openDeleteConfirmationModal = (userId) => {
    setUserToDelete(userId);
    setIsModalOpen(true);
    setOpenMenuId(null)
  };

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);
  
    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  return (
    <MainLayout pageName={"Staff Management"}>
      <div className="staffManagementContainer">
        <div className="staffManagementHeader">
          <div className="staffSearchBox">
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={handleChange}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "7vh",
                width: "25vw",
                borderRadius: "0px",
                color:'black'
              }}
              placeholder="Search"
            />
            <p className="totalCount">
              Total count : {totalCount}
            </p>
          </div>
          <div className="addNewStaffButton" onClick={()=>navigate('addStaff')}>
            <Button buttonStyle={{ height: "1vh" }} title="Add New Staff" />
          </div>
        </div>
        <div className="staffManagementTable">
          <NormalTable
            headerDetails={headerDetails}
            // pagination={true}
          >
            {staffList.length > 0
              ? staffList.map((list,index) => {
                  return (
                    <>
                      <tr key={list.user_id} className="border" style={{ position: "relative" }}>
                      <td style={{paddingLeft:"18px"}}>
                        {search ? index + 1 : (currentPage - 1) * 10 + (index + 1)}
                      </td>
                      <td>{list.firstname} {list.lastname}</td>
                        <td>{list.country_code}&nbsp;{list.mobile}</td>
                        <td>{list.email}</td>
                        <td
                          style={{
                            color: `${
                              list.status == "2" ? "#10CA23" : "#FF482F"
                            }`,
                          }}
                        >
                          {list.status == '2' ? "Active" : "Inactive"}
                        </td>
                        <td >
                          <img
                            style={{ height: "15px", cursor: "pointer" }}
                            src={assets.Icons.optionsIcon}
                            alt="Options"
                            onClick={() => toggleMenu(list.user_id)} // Open menu for this row
                          />
                          {openMenuId === list.user_id && (
                            <div className="optionsMenu">
                              <ul>
                                <li onClick={() => navigate(`viewStaff/${list.user_id}`)}><img src={assets.Icons.viewIcon} alt="" />View</li>
                                <li onClick={()=>  navigate(`editStaff/${list.user_id}`)}><img src={assets.Icons.editIcon} alt="" />Edit</li>
                                <li onClick={() => openDeleteConfirmationModal(list.user_id)}><img src={assets.Icons.deleteIcon} alt="" />Delete</li>
                                <li onClick={() => changeStatus(list.status, list.user_id)}><img src={assets.Icons.activeInactiveIcon} alt="" />Mark as {list.status==2?"Inactive":"Active"}</li>
                              </ul>
                            </div>
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })
              : " "}
          </NormalTable>
          <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
              <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Are you sure you want to delete this Staff?</h3>
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
              <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
               title='Delete'
               onClick={deleteIndividualStaff}
              />
              <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                    width: "40%",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => setIsModalOpen(false)}
                />
            </div>
          </Modal>
          {staffList.length > 0 ? '' :<p style={{textAlign:'center', fontFamily:'poppins', fontSize:"4vh"}}>{isLoading ? "Loading" : "No Data Found"}</p>}
          {staffList.length > 0 ?
          <Pagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={handlePageChange}
          /> : ''}
        </div>
      </div>
    </MainLayout>
  );
};

export default StaffManagement;
